// extracted by mini-css-extract-plugin
export default {"canvaContainer":"CanvaPatient_canvaContainer__deamZ","imgLabel":"CanvaPatient_imgLabel__Du6o3","canvaButtons":"CanvaPatient_canvaButtons__Hf32y"};